<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { mapGetters } from 'vuex';
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';

// NOTICE: KAPTION-INTEGRATION
// Kaption2FA warning banner — shown until the user verifies a WhatsApp
// number. Warning-only: login is untouched; connecting the Rumo MCP is what
// actually requires the verified number.
export default {
  components: { Banner },
  setup() {
    const { isKaptionFlagEnabled } = useKaptionFeatureFlags();
    return { isKaptionFlagEnabled };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
    shouldShowBanner() {
      // NOTICE: KAPTION-INTEGRATION - Dev-only: the server sets KAPTION_SKIP_2FA_NUDGE
      // ONLY when Rails.env.development? (see DashboardController#skip_2fa_nudge?), so
      // this is a no-op in production. It hides the nudge banner and nothing else —
      // enrollment, verification and MCP session binding are untouched.
      if (this.globalConfig?.kaptionSkip2faNudge) return false;

      if (!this.isKaptionFlagEnabled('KAPTION_WHATSAPP_2FA')) return false;

      // Field is absent on older payloads → undefined → banner stays hidden.
      return this.currentUser.kaption_whatsapp_2fa_verified === false;
    },
  },
  methods: {
    goToSettings() {
      this.$router.push({
        name: 'profile_settings_whatsapp_2fa',
        params: { accountId: this.accountId },
      });
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="warning"
    :banner-message="$t('KAPTION_WA2FA.BANNER.MESSAGE')"
    :action-button-label="$t('KAPTION_WA2FA.BANNER.ACTION')"
    action-button-icon="i-lucide-shield-check"
    has-action-button
    @primary-action="goToSettings"
  />
</template>
